import { css } from '@repo/pandacss/styled-system/css';
import { BackToTop } from './BackToTop';
import type { BackToTopLinkProps } from './types';

export function BackToTopLink({ props }: BackToTopLinkProps) {
  return (
    <BackToTop
      className={css({
        color: 'secondary',
        paddingBlockStart: '1',
        paddingBlockEnd: '1',
      })}
      arrowStyle="simple"
      scrollBehavior={props.behavior}
    />
  );
}
